<template>
  <div>

    <Row class="search-con">
      <Col span="10">
        <Button @click="backHistory" class="search-btn">返回</Button>
      </Col>
    </Row>

    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="120"
    >
    <FormItem label="原视频:">
      <Button type='info' size='small' @click="handleDownload(formValidate.video_url)">查看</Button>
    </FormItem>

    <FormItem label="音频:">
      <Button type='info' size='small' @click="handleDownload(formValidate.audio_url)">查看</Button>
    </FormItem>


    <FormItem label="是否需要消除字幕:">
      <label>{{formValidate.rid_subtitles}}</label>
    </FormItem>

    <FormItem label="是否需要换脸:">
      <label>{{formValidate.covert_face}}</label>
    </FormItem>

    <FormItem label="是否需要对口型:">
      <label>{{formValidate.covert_mouth}}</label>
    </FormItem>

    <FormItem label="文案:">
      <Input type="textarea" v-model="formValidate.text"></Input>
    </FormItem>

    <FormItem label="视频模版:" >
        <div class="demo-upload-list" v-for="(item, index) in formValidate.videoModelList">
          <template>
              <Image :src="item"/>
              <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click="handleView(item)"></Icon>
                  <Icon type="md-download" @click="handleDownload(item)"></Icon>
              </div>
          </template>
        </div>
    </FormItem>
    <template v-if="formValidate.covert_face =='需要'">

      <FormItem label="目标人脸:">
        <Button type='info' size='small' @click="handleView(formValidate.face_url)">查看</Button>
      </FormItem>

      <FormItem label="人脸库:" >
          <div class="demo-upload-list" v-for="(item, index) in formValidate.faceList">
            <template>
                <Image :src="item"/>
                <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click="handleView(item)"></Icon>
                    <Icon type="md-download"  @click="handleDownload(item)"></Icon>
                </div>
            </template>
          </div>
      </FormItem>

    </template>

    <template v-if="formValidate.short_video_work_type_id == 7">

      <FormItem label="剧情简介">
        <Col span="18">
          <Input v-model="formValidate.translate_script" type="textarea" disabled  placeholder="请填写"></Input>
        </Col>
      </FormItem>

      <FormItem label="产品型号">
        <Col span="18"> 
          <Input v-model="formValidate.product" type="text" disabled placeholder="请填写"></Input>
        </Col>
      </FormItem>

      <FormItem label="产品图片">
        <template>
              <Image :src="formValidate.product_url"/>
              <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click="handleView(formValidate.product_url)"></Icon>
                  <Icon type="md-download" @click="handleDownload(formValidate.product_url)"></Icon>
              </div>
          </template>
      </FormItem>

      <template v-for="(item, index) in formValidate.users">
        <FormItem
                  :label="'角色' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="text" v-model="item.translate_value" placeholder="请填写"></Input>
                  </Col>

                  <Col span="4" offset="1">
                      <!-- <Button type="error" @click="handleUserRemove(index)">删除</Button> -->
                  </Col>
              </Row>
          </FormItem>
      </template>

      <template v-for="(item, index) in formValidate.props">
        <FormItem
                  :label="'道具' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="text" v-model="item.translate_value" placeholder="请填写"></Input>
                  </Col>

                  <Col span="4" offset="1">
                      <!-- <Button type="error" @click="handlePropRemove(index)">删除</Button> -->
                  </Col>
              </Row>
          </FormItem>
      </template>

      <template v-for="(item, index) in formValidate.scripts">
        <FormItem
                  :label="'场景' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="text"  v-model="item.translate_scene_value" placeholder="请填写"></Input>
                  </Col>
                  <Col span="4" offset="1">
                      <!-- <Button type="error" @click="handleScriptRemove(index)">删除</Button> -->
                  </Col>
              </Row>
            </FormItem>

        <!-- <FormItem
                  :label="'剧情描述' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="textarea"  v-model="item.desc_value" placeholder="请填写"></Input>
                  </Col>
              </Row>
            </FormItem> -->

            <FormItem
                  :label="'话术' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="textarea"  v-model="item.translate_text_value" placeholder="请填写"></Input>
                  </Col>
              </Row>
            </FormItem>
      </template>

    </template>
    </Form>

    <modal title="View Image" v-model="visible">
        <img :src="imgName" v-if="visible" style="width: 100%">
      </modal>

  </div>
</template>

<script>
import { makeVideoDetail, getUserFaceLibrary} from "@/api/data";

export default {
  name: "finance",
  components: {
  },
  data() {
    return {
      visible:false,
      text:'',
      scene:'',
      formValidate: {
        short_video_work_type_id:'',
        videoModelList:[],
        faceList:[],
        video_url: '',
        audio_url:'',
        face_url:'',
        translate_script:'',
        product:'',
        product_url:'',
        users:[],
        props:[],
        scripts:[],
        rid_subtitles:'需要',
        covert_face:'需要',
        covert_mouth:'需要',
      },
      ruleValidate: {
      }
    };
  },
  methods: {
    backHistory() {
      this.$router.go(-1);
    },
    handleView (name) {
      this.visible = true
      this.imgName = name;
    },
    handleDownload (url) {
      window.open(url, '_blank');
    },
    setFacePath(arary){
      for (var i = 0; i < arary.length; i++){
        this.faceList.push(arary[i].face_path)
      }
    },
    setEditData(params){
      var id_url = params.covertAudio.translateText.checkSrtTask.shortVideoTask.id_url
      var url = params.covertAudio.translateText.checkSrtTask.shortVideoTask.url
      this.formValidate.audio_url = params.covertAudio.source_path
      this.formValidate.video_url = id_url == null ?url:id_url

      this.formValidate.rid_subtitles = params.covertAudio.translateText.checkSrtTask.shortVideoTask.rid_subtitles?'需要':'不需要'
      this.formValidate.covert_face = params.covertAudio.translateText.checkSrtTask.shortVideoTask.covert_face?'需要':'不需要'
      this.formValidate.covert_mouth = params.covertAudio.translateText.checkSrtTask.shortVideoTask.covert_mouth?'需要':'不需要'
      this.formValidate.face_url = params.covertAudio.translateText.checkSrtTask.shortVideoTask.face_url

      this.formValidate.scene = params.covertAudio.translateText.translate_scene
      this.formValidate.text = params.covertAudio.translateText.translate_text
      this.formValidate.short_video_work_type_id = params.covertAudio.translateText.checkSrtTask.shortVideoTask.short_video_work_type_id

      if (params.covertAudio.translateText.scene_json != null && params.covertAudio.translateText.scene_json != "null"){
        var scene = JSON.parse(params.covertAudio.translateText.scene_json)
        this.formValidate.scripts = scene.scripts
        this.formValidate.users = scene.users
        this.formValidate.props = scene.props
        this.formValidate.translate_script = scene.translate_script
        this.formValidate.product = scene.product
        this.formValidate.product_url = scene.product_url
      }

      if (params.video_model_url != null){
        this.formValidate.videoModelList = JSON.parse(params.video_model_url)
      }

    },getDetail(){
      var params = {
        id:this.id
      }
      makeVideoDetail(params).then((res) => {
        if (res.data.code == 200) {
          var detailData = res.data.data
          this.setEditData(detailData)
          var dy_user_id = detailData.covertAudio.translateText.checkSrtTask.shortVideoTask.dy_user_id
          getUserFaceLibrary({dy_user_id: dy_user_id}).then((res) => {
              if (res.data.code == 200) {
                var list = res.data.data;
                var data = new Array()
                for (var i = 0; i < list.length; i++) {
                  data[i] = { id: list[i].id.toString(), name: list[i].name }
                }
                this.formValidate.faceList = data
              }
            });
        } 
      });
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetail()
  },
};
</script>
